import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { asDetailTab, type DetailTabId } from '@/features/ai/ai-href';
import { ProviderDetailPage } from '@/features/ai/llm/llm-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** Détail d’un fournisseur : résumé, test de connexion, définition. */
export const Route = createFileRoute('/$tenant/llm/providers/$providerId')({
  validateSearch: (search: Record<string, unknown>): { tab: DetailTabId } => ({
    tab: asDetailTab(search['tab']),
  }),
  component: ProviderDetailRoute,
});

function ProviderDetailRoute() {
  const { tenant, providerId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="llmGateway"
      crumbs={[
        { label: t('nav.items.llmGateway') },
        { label: <EntityName tenantId={tenant} kind="llmProvider" id={providerId} /> },
      ]}
    >
      <ProviderDetailPage
        tenantId={tenant}
        providerId={providerId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
